<div class="container">
    <div class="modal-header">
        <h5 class="mb-0">{{ 'menu.system_parameter_list' | translate }}</h5>
    </div>
    <div class="mt-1">
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="key" class="col-form-label">{{ 'common.id' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="id" formControlName="id" class="form-control" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="value" class="col-form-label">{{ 'common.value' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input *ngIf="isCheckbox" type="checkbox" formControlName="value" class="form-check-input"/>
                    <input *ngIf="!isCheckbox" type="text" formControlName="value" class="form-control"/>
                    <app-field-error-message controlName="value"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="description" class="col-form-label">{{ 'common.description' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <textarea type="text" id="description" formControlName="description" class="form-control"></textarea>
                    <app-field-error-message controlName="description"></app-field-error-message>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" [appClickWait]="onSave" [appClickWait] class="btn btn-primary" themeColor="primary">
            {{ 'common.save' | translate}}
        </button>
        <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
    </div>
</div>

